import React, { Component } from "react";
import "./DirectDebit.css";
import { getApiData } from "../../api/api";
// import axios from "axios";
import { showLoader } from "./../../redux/actions/action_loader";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { connect } from "react-redux";
import Loader from "../Loader/Loader";
import { withTranslation } from "react-i18next";
import AxiosRequest from "../../utils/axios";
import { isNewUI, isPODPosv } from "../../utils/handleProgress";
import DirectDebitNew from "../POSV_New_Ui/DirectDebit2/DirectDebit2";
import DotsLoader from "../Loader/DotsLoader/DotsLoader";
import VideoSubmission from "../POSV_New_Ui/VideoSubmission/VideoSubmission";

const axios = new AxiosRequest().getClient()

class DirectDebit extends Component {
  state = {
    disclaimerChecked: true,
    disclaimerValue: "Yes",
    loading: false,
    isVideoPosv: localStorage.getItem('isVideoPosv'),
    redirectRoute: '',
    showRedirectionScreen: false,
  };
  handleCheckbox = (e) => {
    console.log(e.target.checked);
    this.setState({ disclaimerChecked: true, disclaimerValue: "Yes" });
    // if (e.target.checked === true) {
    //   this.setState({ disclaimerChecked: true, disclaimerValue: "Yes" });
    // } else {
    //   this.setState({ disclaimerChecked: false, disclaimerValue: "No" });
    // }
  };
  componentDidMount = () => {
    this.setState({ loading: true });
    let debitDetails = JSON.parse(localStorage.getItem("digitalDebitData"));
    console.log(debitDetails);
    this.setState({ digitalDebit: debitDetails });
    this.setState({ loading: false });
  };
  handleSubmit = async () => {
    this.setState({ errorMsg: "" });
    let errorMsg = "";
    this.setState({ loading: true });
    let { url, body } = getApiData("saveCustomerResponse");
    body.request.payload.qstCatName = "SIOpted";
    body.request.payload.isSIOpted = this.state.disclaimerValue;
    body.request.payload.customerResponse.qstCatName = "SIOpted";
    delete body.request.payload.customerResponse.qst;
    body.request.payload.planCode = localStorage.getItem("planCode");
    body.request.payload.posvRefNumber = localStorage.getItem("posvRefNumber");

    console.log(url);
    console.log(body);
    // Api call for direct debit submit
    try {
      const response = await axios.post(url, body);
      console.log(response);
      const { isVideoPosv } = this.state
      if (response.data.response.msgInfo.msgCode == 200) {
        if (isNewUI()) {
          this.setState({ showRedirectionScreen: true, redirectRoute: 'selfie' })
          // this.props.history.push("/selfie");
          return
        }
        // check for axis channel
        if (localStorage.getItem("channelName").toLowerCase() === "x") {
          if (isVideoPosv === "Y") {
            this.props.history.push("/video-consent");
          } else {
            this.props.history.push("/declaration");
          }
        } else {
          if (isVideoPosv === "Y") {
            this.props.history.push("/video-consent");
          } else {
            this.props.history.push("/generate_otp");
          }
        }
        return;
      } else {
        errorMsg = response.data.response.payload.businessMsg;
        this.setState({ loading: false, errorMsg });
      }
    } catch (err) {
      errorMsg = "Something went wrong,Please try after some time.";
      console.log(err);
    } finally {
      this.setState({ loading: false, errorMsg });
    }
  };

  redirectToPage = (route) => {
    const { isVideoPosv } = this.state
    if (isNewUI() && !isPODPosv()) {
      this.props.history.push("/selfie");
    } else {
      if (localStorage.getItem("channelName").toLowerCase() === "x") {
        if (isVideoPosv === "Y") {
          this.props.history.push("/video-consent");
        } else {
          this.props.history.push("/declaration");
        }
      } else {
        if (isVideoPosv === "Y") {
          this.props.history.push("/video-consent");
        } else {
          this.props.history.push("/generate_otp");
        }
      }
    }
  }

  render() {

    const { loading, redirectRoute, showRedirectionScreen } = this.state;
    return (
      <>
        {showRedirectionScreen && <VideoSubmission messageTxt={this.props.t("Response_Submitted")} redirectionMsg={redirectRoute} redirectToPage={this.redirectToPage} />}

        {isNewUI()&&this.state.loading && <DotsLoader msg={this.props.t("Please wait")} />}
        {isNewUI() ? <DirectDebitNew loading={loading} handleSubmit={this.handleSubmit} /> :
          <>{
            this.state.digitalDebit && (
              <div className="dd-cntnr">
                <div className="heading">
                  <h2>{this.props.t("Debit_heading")}</h2>
                  <p>{this.props.t("Debit_msg")}</p>
                </div>
                <div className="main-cntnr">
                  <div className="details">
                    {this.state.digitalDebit.accountDetail.map((item, index) => (
                      <div key={index}>
                        <p>{item.accountLabel}</p>
                        <p>
                          <b>{item.accountValue}</b>
                        </p>
                      </div>
                    ))}
                  </div>
                  <div className="note">
                    <p>
                      <span className="bold-txt">{this.state.digitalDebit.accountDisclaimer}</span>
                    </p>
                    <p>
                      <span className="bold-txt">{this.props.t("Debit_msg1")}</span>
                    </p>
                  </div>
                </div>
                <div className="submit-cntnr">
                  <div className="form-check">
                    <input
                      onChange={this.handleCheckbox}
                      className="form-check-input"
                      checked={this.state.disclaimerChecked}
                      disabled={
                        this.state.digitalDebit.paymentMethod == 0 &&
                          !this.state.loading
                          ? false
                          : true
                      }
                      type="checkbox"
                      id="checkbox"
                    />
                    <label htmlFor="checkbox">
                      <small>
                        {this.props.t(this.state.digitalDebit.accountDisclaimerHeading)}
                      </small>
                    </label>
                  </div>
                  <div className="btn-cntnr">
                    {this.state.errorMsg && (
                      <div className="err-cntnr">
                        <small>{this.state.errorMsg}</small>
                      </div>
                    )}
                    <button
                      className="btn btn-primary submit-btn"
                      onClick={this.handleSubmit}
                      disabled={this.state.loading}
                    >
                      {this.props.t("Submit")}
                    </button>
                  </div>
                </div>
              </div>
            )
          }</>}
        {" "}
      </>
    );
  }
}

export default compose(
  withRouter,
  connect(null, { showLoader }),
  withTranslation()
)(DirectDebit);
